/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import { Link } from "react-router-dom";

import { DataTableList } from "../../components/DataTable/DataTableList";
import TopBar from "../../components/TopBar";
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';
import { orderStatus } from "../../utils/constants";
import { getOrders, deleteOrders } from "../../api/ordersApi";

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg";
import down from "../../assets/images/icondropdown.svg";
import searchIcon from "../../assets/images/icon-search.svg";

import styles from './order.module.css'

const AllOrders = () => {
    const [orderList, setOrderList] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [columnWidths, setColumnWidths] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [toggleSelect, setToggleSelect] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const popupRef = useRef();

    // Dropdown states
    const [openStatus, setOpenStatus] = useState(false);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const statusDropdownRef = useRef();

    const [searchInput, setSearchInput] = useState('');

    const calculateColumnWidths = async () => {
        return new Promise((resolve) => {
            const tempWidths = {};

            orderList.forEach((row) => {
                const fields = {
                    orderId: row?.orderId,
                    'customerData.name': row?.customerData?.name,
                    orderCreatedDate: row?.orderCreatedDate,
                    status: row?.status,
                };

                Object.entries(fields).forEach(([key, value]) => {
                    const textLength = value ? value.toString().length : 0;
                    if (!tempWidths[key] || textLength > tempWidths[key]) {
                        tempWidths[key] = textLength;
                    }
                });
            });

            const widthMap = {};
            Object.keys(tempWidths).forEach((key) => {
                widthMap[key] = `${tempWidths[key] * 9 + 40}px`;
            });

            setColumnWidths(widthMap);
            resolve();
        });
    };


    useEffect(() => {
        if (orderList?.length > 0) {
            calculateColumnWidths();
        }
    }, [orderList]);

    useEffect(() => {
        if (Object?.keys(columnWidths)?.length > 0) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 1000);
        }
    }, [columnWidths]);

    // Fetch orders
    const fetchOrders = async () => {
        setIsLoadingData(true)
        try {
            const response = await getOrders({ page: currentPage, search: searchInput, status: selectedStatuses?.join(',') });

            const orders = response?.data?.result || [];
            if (response?.data?.result?.length <= 0) {
                setIsLoadingData(false)
            }
            setOrderList(orders);
            setTotalPage(response?.data?.totalPages)

        } catch (error) {
            console.error('Failed to fetch orders:', error);
            setOrderList([]);
            setIsLoadingData(false)
        }
    };

    useEffect(() => {
        fetchOrders();
    }, [currentPage, selectedStatuses]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setOpenStatus(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleMasterCheckboxChange = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(orderList?.map((row) => row?.id));
        }
        setIsAllSelected(!isAllSelected);
    };

    const handleStatusChange = (status) => {
        setSelectedStatuses(prev => {
            if (prev.includes(status)) {
                const filtered = prev.filter(s => s !== status);
                return filtered.length === 0 ? [] : filtered;
            } else {
                return prev?.length === 0
                    ? [status]
                    : [...prev, status];
            }
        });
    }

    const confirmDelete = async () => {
        if (!deleteTarget) return;

        try {
            if (deleteTarget.type === "single") {
                const response = await deleteOrders([deleteTarget?.row?.id]);
                if (response?.success) {
                    await fetchOrders()
                }
            }

            if (deleteTarget.type === "multiple") {
                const response = await deleteOrders(deleteTarget?.rows);
                if (response?.success) {
                    await fetchOrders()
                }
            }
        } catch (error) {
            console.log('Error deleting pages:', error);
            // Handle error (show notification, etc.)
        }
        setSelectedRows([]);
        setIsAllSelected(false);
        setToggleSelect(prev => !prev);

        setShowDeletePopup(false);
        setDeleteTarget(null);
    };

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
            },
        },
    };

    const columns = [
        {
            name: 'Order_id',
            selector: (row) => row?.orderId,
            cell: (row) => <div className="editTitle"><Link to={`/order/${row?.orderId}`}>{row?.orderId}</Link></div>,
            sortable: true,
            minWidth: columnWidths['orderId'] && `${parseInt(columnWidths['orderId']) + 50}px`,
            style: { width: columnWidths['orderId'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Customer Name',
            selector: (row) => row?.customerData?.name,
            cell: (row) => <div className='editTitle'>{row?.customerData?.name}</div>,
            sortable: true,
            width: columnWidths['customerData.name'] && `${parseInt(columnWidths['customerData.name']) + 50}px`,
            style: { width: `${parseInt(columnWidths['customerData.name'])}px`, paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: 'Date',
            selector: (row) => row?.orderCreatedDate,
            cell: (row) => <div>{moment(row?.orderCreatedDate).tz("Asia/Kolkata").format("DD MMM, YYYY")}</div>,
            sortable: true,
            width: columnWidths['orderCreatedDate'] && `${parseInt(columnWidths['orderCreatedDate']) - 110}px`,
            style: { width: columnWidths['orderCreatedDate'] || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
        },
        {
            name: 'Status',
            selector: (row) => row?.status,
            cell: (row) => <div className={`editStatus ${row?.status}`}>{orderStatus[row?.status] || row?.status}</div>,
            sortable: true,
            width: columnWidths['status'] && `${parseInt(columnWidths['status']) + 30}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },

        },
        {
            name: "Actions",
            cell: (row) => (
                <div className="action-buttons">
                    <Link to={`/order/${row?.orderId}`}><button className="edit-btn" disabled={row?.status === 'Delivered'}><img src={penIcon} alt="pen-icon" /></button></Link>
                    <button className="delete-btn" onClick={() => {
                        setDeleteTarget({ type: "single", row });
                        setShowDeletePopup(true);
                    }}><img src={Delete} alt="delete-icon" /></button>
                </div>
            ),
            width: "90px"
        }
    ];

    const handleSearch = async () => {
        await fetchOrders();
    }

    return (
        <div className={`${styles.orderList} ${orderList?.length <= 10 && `${styles.orderListHeight}`}`}>
            <TopBar />

            <div className={`${styles.orderDatatableList}`}>

                <div className={`${styles.orderHeader}`}>
                    <div className={`${styles.leftSide}`}>
                        {/* <div className={`${styles.orderHeading}`}>Orders</div> */}
                        <div className={`${styles.searchBar}`}>
                            <img src={searchIcon} alt="Search" />
                            <input
                                type="text"
                                placeholder="Search by order ID or client name..."
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </div>
                        <button className={`${styles.addBtn}`} onClick={() => handleSearch()}>Search</button>
                    </div>
                    <div className={`${styles.actionButtonsDeleteAdd}`}>
                        <div className="dropdown-wrapper order-status-dropdown" ref={statusDropdownRef}>
                            <div className="dropdown-header " onClick={() => setOpenStatus(!openStatus)}>
                                <span className="title">Status</span>
                                <span className={`arrow ${openStatus ? "rotate" : ""}`}><img src={down} alt="down-icon"/></span>
                            </div>
                            {openStatus && (
                                <div className="dropdown-list" >
                                    {Object.entries(orderStatus).map(([key, label]) => (
                                        <label key={key} className="dropdown-item">
                                            <input
                                                type="checkbox"
                                                checked={selectedStatuses.includes(key)}
                                                onChange={() => handleStatusChange(key)}
                                            />
                                            <span>{label}</span>
                                        </label>
                                    ))}

                                </div>
                            )}
                        </div>
                        <Link to={`/new-order`}><button className={`${styles.addBtn}`}>Add Order</button></Link>
                        {selectedRows?.length > 0 && (
                            <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                                setDeleteTarget({ type: "multiple", rows: selectedRows });
                                setShowDeletePopup(true);
                            }}>
                                <img src={Delete} alt="delete-icon" />
                            </div>
                        )}
                    </div>
                </div>

                <div className={`pagesTable dataTable-list ${orderList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
                    <DataTableList
                        columns={columns}
                        data={orderList}
                        onSelectedRowsChange={({ selectedRows }) => {
                            const selectedIds = selectedRows?.map((row) => row?.id);
                            setSelectedRows(selectedIds);
                            setIsAllSelected(selectedIds.length === orderList?.length);
                        }}
                        progressPending={isLoadingData}
                        currentPage={currentPage}
                        onChangePage={setCurrentPage}
                        paginationTotalRows={totalPage}
                        selectableRows
                        selectAllRows={isAllSelected}
                        clearSelectedRows={toggleSelect}
                        onSelectAllChange={handleMasterCheckboxChange}
                        customStyles={customStyles}
                        selectableRowsComponent="input"
                        progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
                    // noDataComponent={<NoResultsPublication />}
                    />
                </div>
            </div>
            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                reference={popupRef}
                confirmDelete={confirmDelete}
                setShowDeletePopup={setShowDeletePopup}
                onCancel={() => setShowDeletePopup(false)}
                title={deleteTarget?.type === "single" ? 'order' : selectedRows?.length === 1 ? 'order' : `orders`}
                description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.orderId}?` : selectedRows?.length === 1 ? `Are you sure you want to delete order?` : `Are you sure you want to delete ${selectedRows?.length} order?`}

            />

        </div>
    )
}
export default AllOrders;
